module.exports = __webpack_public_path__ + "static/media/aquaria-klcc.7f33de20.jpeg";